export default "__VITE_ASSET__fXia2zmi__"